import { render, staticRenderFns } from "./OrderEasy.vue?vue&type=template&id=3de70681"
import script from "./OrderEasy.vue?vue&type=script&lang=js"
export * from "./OrderEasy.vue?vue&type=script&lang=js"
import style0 from "./OrderEasy.vue?vue&type=style&index=0&id=3de70681&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports